import { Link } from "react-router-dom";

const LOGO_URL = "/images/logo.png";

const footerLinks = {
  navigation: [
    { path: "/", label: "Accueil" },
    { path: "/reparation", label: "Réparation" },
    { path: "/accessoires", label: "Accessoires" },
    { path: "/contact", label: "Contact" },
  ],
  services: [
    "Écran",
    "Batterie",
    "Connecteur de charge",
    "Micro / haut-parleur",
    "Caméra",
    "Mise à jour logiciel",
    "Désoxydation",
    "Tablette",
    "Console de jeux",
  ],
  legal: [
    { path: "/mentions-legales", label: "Mentions légales" },
    { path: "/politique-de-confidentialite", label: "Politique de confidentialité" },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-oya-cream border-t border-oya-gray-light">
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-8">
          <div className="sm:col-span-2 lg:col-span-1">
            <Link to="/" className="inline-block">
              <img
                src={LOGO_URL}
                alt="OYA PHONE"
                className="h-14 md:h-16 w-auto object-contain"
              />
            </Link>
            <p className="mt-4 text-sm text-oya-gray-medium leading-relaxed">
              7, Quélerec
              <br />
              29840 Landunvez
            </p>
            <p className="mt-2 text-sm text-oya-gray-medium">
              <a href="tel:0651004790" className="hover:text-oya-red transition-colors">
                06 51 00 47 90
              </a>
            </p>
            <p className="mt-1 text-sm text-oya-gray-medium">
              <a href="mailto:oyaphone29@gmail.com" className="hover:text-oya-red transition-colors">
                oyaphone29@gmail.com
              </a>
            </p>
            <p className="mt-3 text-xs text-oya-gray-medium">
              Mardi – Samedi
              <br />
              10h-12h30 / 15h-18h30
            </p>
          </div>

          <div>
            <h4 className="text-xs font-bold uppercase tracking-wider text-oya-black mb-4">
              Navigation
            </h4>
            <ul className="space-y-2">
              {footerLinks.navigation.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-sm text-oya-gray-medium hover:text-oya-red transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-xs font-bold uppercase tracking-wider text-oya-black mb-4">
              Services
            </h4>
            <ul className="space-y-2">
              {footerLinks.services.map((service) => (
                <li key={service}>
                  <span className="text-sm text-oya-gray-medium">{service}</span>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-xs font-bold uppercase tracking-wider text-oya-black mb-4">
              Légal
            </h4>
            <ul className="space-y-2">
              {footerLinks.legal.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-sm text-oya-gray-medium hover:text-oya-red transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-oya-gray-light flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-oya-gray-medium">
            &copy; {new Date().getFullYear()} OYA PHONE. Tous droits réservés.
          </p>
          <p className="text-xs text-oya-gray-medium/70">
            Certains liens peuvent être affiliés. Cela ne change pas le prix pour vous.
          </p>
        </div>
      </div>
    </footer>
  );
}